// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__-eOcs","actions":"Pagination_actions__bDShB","wrapperActions":"Pagination_wrapperActions__dlf78","goToPage":"Pagination_goToPage__hFmnN"};